import { getPieceFilterMapping } from "../../features/createSecondaryOrder/CreateSecondaryOrderService";
import "./CatalogueFiltersNew.css";

interface CatalogueFiltersPropTypes {
  filterOptions: Record<string, string[]>;
  selectedFilters: Record<string, string>;
  updateFilterSelection: (filterType: string, option: string, rowIndex:number) => void;
  filtersConfig:string[];
}

/**
 * CatalogueFiltersNew component
 * 
 * This component renders a set of filters for a catalogue
 * It takes in three props:
 *  - filterOptions: an object where the keys are the names of the filters and the values are arrays of possible values for that filter
 *  - selectedFilters: an object where the keys are the names of the filters and the values are the currently selected values for that filter
 *  - updateFilterSelection: a function that takes in a filter type and a value and updates the selected filters with that value
 *  - filtersConfig: an array of strings specifying the order of the filters
 * 
 * The component renders a row for each filter with an 'All' option and then a set of options for that filter
 * When an option is selected, the updateFilterSelection function is called with the filter type and the selected value
 */
const CatalogueFiltersNew: React.FC<CatalogueFiltersPropTypes> = ({
  filterOptions,
  selectedFilters,
  updateFilterSelection,
  filtersConfig,
}) => {

  const checkFilterAppliedForType = (type: string) => {
    return type in selectedFilters && selectedFilters[type] !== "ALL";
  };

  const checkFilterAppliedForOption = (type: string, option: string) => {
    return type in selectedFilters && selectedFilters[type] === option;
  };

  const totalFilterTypes = Object.keys(filterOptions).length;

  return (
    <div className="catalogueFiltersWrapper" style={{height: `${37*totalFilterTypes}px`}}>
      <div className="catalogue-filters-container">
        {filtersConfig.map((type,index) => {
          const filters = filterOptions[type];
          if (!filters) return null;
          return (
            <div className="catalogue-filters-row">
              <div
                className={`option-box ${!checkFilterAppliedForType(type) && "active-filter"}`}
                onClick={() => updateFilterSelection(type, "ALL",index)}
              >
                All
              </div>
              <div className="filter-type-container" key={type}>
                {filters?.map((option: any) => {
                  return (
                    <div
                      className={`option-box ${
                        checkFilterAppliedForOption(type, option) && "active-filter"
                      }`}
                      key={option}
                      onClick={() => updateFilterSelection(type, option,index)}
                    >
                      {type === "pieceSize" ? getPieceFilterMapping(option) : option}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CatalogueFiltersNew;
